class HmMembershipInfo extends HTMLElement {
  connectedCallback() {
    this.drawer = this.querySelector('[data-membership-drawer]');
    this.overlay = this.querySelector('[data-drawer-overlay]');
    this.drawerTitle = this.querySelector('[data-drawer-title]');
    this.drawerContent = this.querySelector('[data-drawer-content]');
    this.movePanelsIntoDrawer();
    this.openButtons = this.querySelectorAll('[data-benefit-open]');
    this.closeButtons = this.querySelectorAll('[data-drawer-close]');
    this.panels = this.querySelectorAll('[data-benefit-panel]');
    this.searchInput = this.querySelector('[data-faq-search]');
    this.searchClear = this.querySelector('[data-faq-search-clear]');
    this.faqItems = this.querySelectorAll('[data-faq-item]');
    this.emptyState = this.querySelector('[data-faq-empty]');
    this.inertedElements = [];

    this.openButtons.forEach((button) => {
      button.addEventListener('click', this.handleOpen);
    });
    this.closeButtons.forEach((button) => {
      button.addEventListener('click', this.closeDrawer);
    });
    this.overlay?.addEventListener('click', this.closeDrawer);
    this.searchInput?.addEventListener('input', this.handleSearch);
    this.searchClear?.addEventListener('click', this.handleClearSearch);
    document.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    this.openButtons?.forEach((button) => {
      button.removeEventListener('click', this.handleOpen);
    });
    this.closeButtons?.forEach((button) => {
      button.removeEventListener('click', this.closeDrawer);
    });
    this.overlay?.removeEventListener('click', this.closeDrawer);
    this.searchInput?.removeEventListener('input', this.handleSearch);
    this.searchClear?.removeEventListener('click', this.handleClearSearch);
    document.removeEventListener('keydown', this.handleKeydown);
    this.unlockBackground();
  }

  movePanelsIntoDrawer = () => {
    if (!this.drawerContent) return;

    this.querySelectorAll('[data-benefit-panel]').forEach((panel) => {
      this.drawerContent.appendChild(panel);
    });
  };

  handleOpen = (event) => {
    const button = event.currentTarget;
    const panelId = button.getAttribute('data-benefit-open');
    const panel = this.querySelector(`[data-benefit-panel="${CSS.escape(panelId)}"]`);

    if (!panel || !this.drawer || !this.overlay) return;

    this.activeElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    this.panels.forEach((item) => {
      item.hidden = item !== panel;
    });

    if (this.drawerTitle) {
      this.drawerTitle.textContent = panel.getAttribute('data-benefit-title') || '';
    }

    this.drawer.hidden = false;
    this.overlay.hidden = false;
    document.documentElement.setAttribute('scroll-lock', '');
    this.lockBackground();
    this.drawer.focus({ preventScroll: true });
  };

  closeDrawer = () => {
    if (!this.drawer || this.drawer.hidden) return;

    this.drawer.hidden = true;
    if (this.overlay) this.overlay.hidden = true;
    document.documentElement.removeAttribute('scroll-lock');
    this.unlockBackground();
    this.panels.forEach((item) => {
      item.hidden = true;
    });
    this.activeElement?.focus({ preventScroll: true });
  };

  lockBackground = () => {
    const keepVisible = new Set([this.drawer, this.overlay]);

    Array.from(this.children).forEach((child) => {
      if (!keepVisible.has(child) && !child.hasAttribute('inert')) {
        child.setAttribute('inert', '');
        this.inertedElements.push(child);
      }
    });

    let node = this;
    while (node && node !== document.body) {
      const parent = node.parentElement;
      if (parent) {
        Array.from(parent.children).forEach((sibling) => {
          if (sibling !== node && !sibling.hasAttribute('inert')) {
            sibling.setAttribute('inert', '');
            this.inertedElements.push(sibling);
          }
        });
      }
      node = parent;
    }
  };

  unlockBackground = () => {
    this.inertedElements.forEach((el) => el.removeAttribute('inert'));
    this.inertedElements = [];
  };

  handleKeydown = (event) => {
    if (!this.drawer || this.drawer.hidden) return;

    if (event.key === 'Escape') {
      this.closeDrawer();
      return;
    }

    if (event.key === 'Tab') {
      this.trapFocus(event);
    }
  };

  trapFocus = (event) => {
    const focusable = this.drawer.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  handleSearch = () => {
    const query = this.searchInput.value.trim().toLowerCase();
    let visibleCount = 0;

    this.faqItems.forEach((item) => {
      const matches = item.textContent.toLowerCase().includes(query);
      item.hidden = query !== '' && !matches;
      if (!item.hidden) visibleCount += 1;
    });

    if (this.emptyState) {
      this.emptyState.hidden = visibleCount !== 0;
    }
  };

  handleClearSearch = () => {
    if (!this.searchInput) return;

    this.searchInput.value = '';
    this.searchInput.focus();
    this.handleSearch();
  };
}

if (!customElements.get('hm-membership-info')) {
  customElements.define('hm-membership-info', HmMembershipInfo);
}
